export const formatFileSize = (fileSizeBytes: number) => 
    `${(fileSizeBytes / (1024 * 1024)).toFixed(2)}MB`;
